import {IDLE} from "../../../common/statuses";

export const initialState = {
    courses: {
        mental: undefined,
        status: IDLE
    }
}
